import PropTypes from 'prop-types';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

const StyledTooltip = styled(ReactTooltip)`
  ${({ withBoxShadow }) =>
    withBoxShadow &&
    'box-shadow: 0px 12px 15px rgba(151, 152, 153, 0.3) !important;'}
  opacity: 1 !important;
  padding: ${props => props.padding};
  border-radius: 8px !important;
  font-weight: 400 !important;
  font-size: 14 !important;
  font-style: normal !important;
  max-width: 500px !important;
  line-height: 23px !important;
  white-space: break-spaces;
`;

StyledTooltip.defaultProps = {
  padding: '20px',
};

const Tooltip = ({
  id,
  padding,
  getContent,
  afterHide,
  withBoxShadow = true,
  place = 'bottom',
}) => {
  return (
    <StyledTooltip
      type="light"
      place={place}
      effect="solid"
      backgroundColor="white"
      padding={padding}
      id={id}
      getContent={getContent}
      afterHide={afterHide}
      withBoxShadow={withBoxShadow}
      arrowColor="transparent"
    />
  );
};

Tooltip.propTypes = {
  id: PropTypes.string,
  padding: PropTypes.string,
  getContent: PropTypes.func,
  afterHide: PropTypes.func,
  withBoxShadow: PropTypes.bool,
  place: PropTypes.string,
};

export default Tooltip;
